import Button from "../Button";
import FoundryLink from "../../components/FoundryLink";
import styles from "./ShoppingHeader.module.scss";

interface Props {
  title: string;
  hidePackageDiscounts?: boolean;
  buttonText?: string;
  buttonOnClick?: () => void;
  containerClass?: string;
}

export default function ShoppingHeader(props: Props) {
  const containerClass = props.containerClass || "container-wide";
  return (
    <section className={styles.shoppingHeaderContainer}>
      <div className="flex flex-col z-10 h-full relative justify-end nav-spacer--padded">
        <div className={styles.bg} />
        {props.buttonText && (
          <Button onClick={props.buttonOnClick}>{props.buttonText}</Button>
        )}
        {process.env.NEXT_PUBLIC_ENABLE_FOUNDRY ? (
          <div className="bg-riso-container relative flex flex-col md:flex-row z-10">
            <span
              className={`t6 flex-grow py-4 px-16 md:px-4 bg-yellow color-green ${
                props.hidePackageDiscounts
                  ? "container-full text-center"
                  : "text-center"
              }`}
            >
              Questions? Refer to our{" "}
              <FoundryLink href="/" className="underline">
                FAQs
              </FoundryLink>
              ,{" "}
              <FoundryLink href="/" className="underline">
                EULA
              </FoundryLink>
              , or{" "}
              <FoundryLink href="/" className="underline">
                contact us directly →
              </FoundryLink>
            </span>
            {!props.hidePackageDiscounts && (
              <span className="t6 flex-grow text-center py-4 px-16 md:px-4 bg-pink color-blue">
                Package discounts apply as you add more to your cart ~
              </span>
            )}
          </div>
        ) : (
          <div className="flex flex-row">
            <span className="t6 flex-grow p-4 bg-yellow color-green container-full z-10"></span>
          </div>
        )}
      </div>
      <div className={`relative ${containerClass} mt-16`}>
        <h1
          className={`text-5xl pb-6 capitalize color-blue mix-blend-multiply opacity-80`}
        >
          {props.title}
        </h1>
        <h1
          className={`text-5xl pb-6 capitalize color-mint absolute top-0 mix-blend-multiply squiggly`}
          style={{ transform: "translate(2px, 1px) rotate(-1deg)" }}
        >
          <span className="opacity-30">{props.title}</span>
        </h1>
      </div>
    </section>
  );
}
